package com.nonopn.skywatcher.common.api

import kotlinx.serialization.Serializable

// Email lightning alert settings, stored by the Strike Radar alert service (o2switch).
@Serializable
data class AlertSettingsRequest(
    val zone: String? = null,
    val emailEnabled: Boolean? = null,
    val email: String? = null,
)

@Serializable
data class AlertSettingsAnswer(
    val zone: String = "none",
    val emailEnabled: Boolean = true,
    val email: String = "",
    val projects: Int = 0,
    val eligible: Boolean = false,
)
